module.exports = __webpack_public_path__ + "views/mailbox.ddcdf8c0cc9d58338d38b8abdf412768.html";